import Glasshour from '../../../assets/glasshour.svg';

const GlasshourIcon = (props: React.SVGProps<SVGSVGElement> & { color: string }): JSX.Element => {
  return <Glasshour fill={props.color} {...props} />;
};

export default GlasshourIcon;
